@if (data && data.columns) {
  @if (data.url) {
    <a
      [href]="data.url"
      class="list-item"
      [ngClass]="{ __inactive: data.inactive, '__align-row-sm': data.alignSm === 'row' }">
      <ng-container *ngTemplateOutlet="inner"></ng-container>
    </a>
  } @else {
    <div
      role="link"
      class="list-item"
      [ngClass]="{ __inactive: data.inactive, '__align-row-sm': data.alignSm === 'row' }"
      (click)="onClicked.emit()">
      <ng-container *ngTemplateOutlet="inner"></ng-container>
    </div>
  }

  <ng-template #inner>
    @for (col of data.columns; track $index) {
      @if ((col.hideIfNotAdmin && data.isAdmin) || !col.hideIfNotAdmin) {
        <div class="__col" [class]="getColClassList(col)">
          @if (col.image) {
            <div class="__image">
              <img
                [src]="(col.image.src | profileImage | async) ?? '/assets/images/image-avatar-fallback.svg' | sanitize"
                [alt]="col.image.alt" />
            </div>
          }
          @for (line of col.lines; track $index) {
            <div class="__line relative" title="{{ line.title }}" [ngClass]="{ __truncate: line.truncate }">
              <app-tooltip
                [text]=line.content
              >
                @if (line.strong) {
                  <strong [innerHTML]="line.content"></strong>
                } @else {
                  <span [innerHTML]="line.content"></span>
                }
              </app-tooltip>
            </div>
          }
        </div>
      }
    }
  </ng-template>
}
